import { api } from "constants/RotasAPI";
import { LoadingContext } from "context/LoadingContext";
import { useContext } from "react";
import { toast } from "react-hot-toast";
import { downloadFile } from "shared/util/functions/download/DownloadFunctions";
import { http } from "shared/util/http";

export const useGetEmitirRelatorioConfissaoDeDivida = () => {
  const { setLoading } = useContext(LoadingContext);

  const emitirRelatorioConfissaoDeDivida = async (acordoId: number) => {
    setLoading(true);
    await http
      .get(`${api.relatorios.emitirRelatorioConfissaoDeDivida}/${acordoId}`)
      .then((response) => {
        toast.success("Relatório emitido com sucesso");
        downloadFile(
          response.data,
          `Termo de acordo e confissão de dívida`,
          "application/pdf",
          false
        );
      })
      .catch((error) => {
        toast.error("Erro ao gerar termo de acordo e confissão de dívida");
      })
      .finally(() => setLoading(false));
  };

  return { emitirRelatorioConfissaoDeDivida };
};
